'use client'

import { useTranslations } from 'next-intl'

import { LayoutGrid } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { ALL_STORIES_COLLECTION, openCollection } from './mood-filter'

/**
 * The all-stories index's entry into the browsable view: a
 * `<button>` — never an anchor, so the `?collection=all` state stays
 * uncrawlable — that swaps the homepage to the tile grid the same way a mood
 * tile does. The tiny client island keeps `BlogAllStories` itself a server
 * component (its per-post links must be server HTML).
 */
export const BrowseAllStoriesButton = () => {
    const t = useTranslations('blogHome.allStories')

    return (
        <Button variant="outline" onClick={() => openCollection(ALL_STORIES_COLLECTION)}>
            <LayoutGrid aria-hidden="true" className="size-4" />
            {t('browseAll')}
        </Button>
    )
}
